import { Component, HostBinding, OnInit, inject } from '@angular/core';

import { OidcSecurityService } from 'angular-auth-oidc-client';

import { CountriesService } from './core/countries/countries.service';
import { SettingsService } from './core/settings/settings.service';
import { TranslatorService } from './core/translator/translator.service';
import { ServicesStartupService } from './services/services-startup/services-startup.service';
import { RouterOutlet } from '@angular/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [RouterOutlet, LoadingBarModule]
})
export class AppComponent implements OnInit {
	settings = inject(SettingsService);
	oidcSecurityService = inject(OidcSecurityService);
	translate = inject(TranslatorService);
	private countriesService = inject(CountriesService);
	private servicesStartupService = inject(ServicesStartupService);

	@HostBinding('class.layout-fixed') get isFixed() {
		return this.settings.getLayoutSetting('isFixed');
	}
	@HostBinding('class.aside-collapsed') get isCollapsed() {
		return this.settings.getLayoutSetting('isCollapsed');
	}
	@HostBinding('class.layout-boxed') get isBoxed() {
		return this.settings.getLayoutSetting('isBoxed');
	}
	@HostBinding('class.layout-fs') get useFullLayout() {
		return this.settings.getLayoutSetting('useFullLayout');
	}
	@HostBinding('class.hidden-footer') get hiddenFooter() {
		return this.settings.getLayoutSetting('hiddenFooter');
	}
	@HostBinding('class.layout-h') get horizontal() {
		return this.settings.getLayoutSetting('horizontal');
	}
	@HostBinding('class.aside-float') get isFloat() {
		return this.settings.getLayoutSetting('isFloat');
	}
	@HostBinding('class.offsidebar-open') get offsidebarOpen() {
		return this.settings.getLayoutSetting('offsidebarOpen');
	}
	@HostBinding('class.aside-toggled') get asideToggled() {
		return this.settings.getLayoutSetting('asideToggled');
	}
	@HostBinding('class.aside-collapsed-text') get isCollapsedText() {
		return this.settings.getLayoutSetting('isCollapsedText');
	}

	ngOnInit(): void {
		document.addEventListener('click', (e) => {
			const target = e.target as HTMLElement;
			if (
				target.tagName === 'A' &&
				['', '#'].indexOf(target.getAttribute('href')) > -1
			)
				e.preventDefault();
		});

		// Initialize core services
		this.translate.init();
		this.countriesService.initialize();
		this.servicesStartupService.initialize();
	}
}
